// extracted by mini-css-extract-plugin
export default {"void":"#0b0f10","space":"#151b1e","metal":"rgba(46,55,58,.8666666667)","shine":"#32bce5","star":"#e7e7f1","warning":"#ffc107","info":"#89898f","secondary":"#6ba5bd"};